<template>
  <div class="sp-template">
    <div class="h-title">账户信息</div>
    <el-card class="box-card">
      <el-form :model="form" size="small" :rules="formRule" ref="form">
        <el-row>
          <h2 class="sp-card-title">基本信息&nbsp;&nbsp;
            <el-button size="mini" v-show="in_configs(50102) && !ishandler" type="primary" @click="handleEdit()">编 辑</el-button>
            <el-button size="mini" v-show="ishandler" @click="cancelEdit()">取 消</el-button>
            <el-button size="mini" v-show="ishandler" type="primary" @click="handlerSave">保 存</el-button>
          </h2>
          <el-col :span="10">
            <el-form-item label="账户名称" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{form.username}}</span>
              <el-input v-else v-model.lazy="data.username" placeholder="账户名称"></el-input>
            </el-form-item>
            <el-form-item label="登录密码" :label-width="formLabelWidth" prop="password" >
              <span v-if="!ishandler">**************</span>
              <el-input v-else v-model.lazy="data.password" type="password" placeholder="登录密码"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" v-show="data.password && data.password.length > 0" :label-width="formLabelWidth" prop="password2" >
              <el-input v-model.lazy="data.password2" type="password" placeholder="确认密码"></el-input>
            </el-form-item>
            <el-form-item label="注册姓名" :label-width="formLabelWidth" prop="name">
              <span v-if="!ishandler">{{form.name}}</span>
              <el-input v-else v-model.lazy="data.name" placeholder="注册姓名"></el-input>
            </el-form-item>
            <el-form-item label="注册电话" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{form.phone}}</span>
              <el-input v-else v-model.lazy="data.phone" placeholder="注册电话"></el-input>
            </el-form-item>
            <el-form-item label="注册邮箱" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{form.email}}</span>
              <el-input v-else v-model.lazy="data.email" placeholder="注册邮箱"></el-input>
            </el-form-item>
            <el-form-item label="组织名称" v-show="false" :label-width="formLabelWidth">
              <span >{{data.test}}</span>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <h2 class="sp-card-title" v-show="false">其他信息</h2>
          <el-col :span="10" v-show="false">
            <el-form-item label="客户类型" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{data.test}}</span>
              <el-input v-else v-model.lazy="form.test" placeholder="客户类型"></el-input>
            </el-form-item>
            <el-form-item label="信用额度" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{data.test}}</span>
              <el-input v-else v-model.lazy="form.test" placeholder="信用额度">
                <template slot="prepend">￥</template>
              </el-input>
            </el-form-item>
            <el-form-item label="客服电话" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{data.test}}</span>
              <el-input v-else v-model.lazy="form.test" placeholder="客服电话"></el-input>
            </el-form-item>
            <el-form-item label="业务电话" :label-width="formLabelWidth">
              <span v-if="!ishandler">{{data.test}}</span>
              <el-input v-else v-model.lazy="form.test" placeholder="业务电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </el-card>
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="">
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    var checkPassword = (rule, value, callback) => {
      if (this.data.password && this.data.password.length < 6) {
        callback(new Error("密码长度必须大于6位数"));
      } else {
        callback();
      }
    };
    var checkPassword2 = (rule, value, callback) => {
      if (this.data.password2 && this.data.password2.length < 6) {
        callback(new Error("密码长度必须大于6位数"));
      } else if (this.data.password2 != this.data.password) {
        callback(new Error("2次密码输入不一致"));
      } else {
        callback();
      }
    };
    var checkName = (rule, value, callback) => {
      if (!this.data.name || this.data.name == "") {
        callback(new Error("用户名不能为空"));
      } else {
        callback();
      }
    };
    return {
      data: { name: "", password: "", email: "", test: "" },
      form: {},
      customer: [{ name: "666", value: "001" }, { name: "777", value: "002" }],
      formLabelWidth: "120px",
      dialogImageUrl: "", //上传图片
      dialogVisible: false,
      ishandler: false,
      formRule: {
        password: [{ validator: checkPassword, trigger: "blur" }],
        password2: [{ validator: checkPassword2, trigger: "blur" }],
        name: [{ validator: checkName, trigger: "blur" }]
      }
    };
  },
  components: {},
  created() {
    setTimeout(() => {
      this.loadProfile();
    }, 800);
  },
  computed: {},
  methods: {
    handleEdit() {
      this.ishandler = true;
      this.data = JSON.parse(JSON.stringify(this.form));
    },
    handlerSave() {
      let _this = this;
      let _check = true;
      _this.$request1
        .all([_this.checkUsernameAjax(), _this.checkEmailAjax()])
        .then(
          _this.$request1.spread(function(username, email) {
            console.log(username);
            if (_this.data.username != _this.form.username) {
              if (!username.data.success) {
                _this.$notify.error({
                  title: "错误",
                  message: username.data.message
                });
                _check = false;
              }
            }
            if (_this.data.email != _this.form.email) {
              if (!email.data.success) {
                _this.$notify.error({
                  title: "错误",
                  message: email.data.message
                });
                _check = false;
              }
            }
            if (!_check) {
              return false;
            }

            let _validBottom = true;
            _this.$refs["form"].validate(valid => {
              if (!valid) {
                _validBottom = false;
              }
            });
            if (!_validBottom) {
              return false;
            }

            _this.$request1({
                method: 'POST',
                url: '/user',
                params: {
                  id: _this.data.id,
                  username: _this.data.username,
                  password: _this.data.password,
                  email: _this.data.email,
                  name: _this.data.name,
                  phone: _this.data.phone
                }
              })
              .then(response => {
                if (response.data.success) {
                  _this.form = JSON.parse(JSON.stringify(_this.data));
                  _this.data.password = "";
                  _this.data.password2 = "";
                  _this.ishandler = false;
                } else {
                  _this.$notify.error({
                    title: "错误",
                    message: response.data.message
                  });
                }
              })
              .catch(error => {
                console.log(error);
              });
          })
        );
    },
    cancelEdit() {
      this.ishandler = false;
      this.loadProfile();
    },
    checkEmailAjax() {
      let _this = this;
      return this.$request1.get(
        '/customer/email/check',
        {
          params: {
            email: _this.data.email
          }
        }
      );
    },
    checkUsernameAjax() {
      let _this = this;
      return this.$request1.get(
        '/customer/user/check',
        {
          params: {
            userName: _this.data.username
          }
        }
      );
    },
    //上传图片
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    loadProfile() {
      let _this = this;
      _this.$request1({
          method: 'GET',
          url: '/user'
        })
        .then(response => {
          console.log(response);
          if (response.data.success) {
            this.form = response.data.data;
          } else {
            this.$notify.error({
              title: "错误",
              message: response.data.message
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>

</style>


// WEBPACK FOOTER //
// src/views/usercenter/userinfo.vue